// Force build counter: 2
import Promise from 'bluebird'
import Store from 'store'
import { generate as genId } from 'shortid'
import axios from 'axios'

function request(method, path, data = {}) {
  return axios({
    method,
    url: `${process.env.API_ROOT}/v1${path}`,
    headers: {
      Authorization: `Bearer ${Store.get('authToken')}`,
    },
    data,
  }).catch(err => {
    if (err.request && err.request.status === 403) {
      Store.remove('authToken')
      return (window.location.href = '/login')
    }

    err._apierror = true
    console.log(err)
    return err
  })
}

let processQuery = (path, query) => {
  if (typeof query === 'object') {
    let queryParts = []

    for (let key in query) {
      let value = query[key]
      queryParts.push(key + '=' + encodeURIComponent(value))
    }

    path = `${path}?${queryParts.join('&')}`
  }
  return path
}

const Api = {
  get(path, query = false) {
    return request('GET', processQuery(path, query))
  },
  post(path, data, query = false) {
    return request('POST', processQuery(path, query), data)
  },
  patch(path, data, query = false) {
    return request('PATCH', processQuery(path, query), data)
  },
  delete(path, data, query = false) {
    return request('DELETE', processQuery(path, query), data)
  },
}

export default Api
